// Directiva para controlar si se llega al final del scroll y lanzar una page+1 uy poder implementar un sistema de paginación
(function(){
    angular
        .module('appback')
        .directive('ngScrollpagination', scrollpagination);
        scrollpagination.$inject = ['$timeout'];
        function scrollpagination($timeout){
            return {
              scope:{
                filtros:"=",
                callback : "&"
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                    $(element).scroll(function(){
                        var divHeight = $(this)[0].scrollHeight;
                        var outerHeight = $(this).outerHeight();
                        var scrollTop = $(this).scrollTop();
                        var suma = outerHeight+scrollTop;  
                        // Si esto se iguala es que se llegó al final
                        if(divHeight==(suma)){
                            scope.filtros.page++;
                            scope.callback();
                        }
                    })
                });
            }
          }
      }
})();